var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alertTrend-container"},[_c('div',{staticClass:"rangeContainer"},[_c('simple-select',{attrs:{"options":_vm.rangeOptions,"autoSelect":false,"label-in-value":false},model:{value:(_vm.currentRange),callback:function ($$v) {_vm.currentRange=$$v},expression:"currentRange"}})],1),_c('a-spin',{attrs:{"spinning":_vm.loading}},[(_vm.trendData.length)?_c('div',{staticStyle:{"padding":"10px"}},[_c('line-chart',{attrs:{"chartId":"alert-history-trend-chart","legendPosition":"top","colorType":"name","chartData":_vm.trendData,"colors":[_vm.redColor, _vm.orangeColor, _vm.blueColor, '#38D3FA'],"height":268,"showArea":true,"legendOptions":{
          position: 'top',
          offsetY: 0
        }}})],1):_c('div',{staticStyle:{"position":"relative","overflow":"hidden"}},[_c('empty-component',{attrs:{"body-style":{
          height: '186px',
          marginTop: '44px'
        },"description-style":{
          marginTop: '-32px'
        }}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }